import { Star } from "lucide-react";

export function StarRating({ value = 0, size = 14, className = "" }) {
  const full = Math.round(value);
  return (
    <div className={`inline-flex items-center gap-0.5 ${className}`} aria-label={`${value} stars`}>
      {[1, 2, 3, 4, 5].map((i) => (
        <Star
          key={i}
          size={size}
          className={i <= full ? "fill-accent text-accent" : "text-muted-foreground/40"}
        />
      ))}
    </div>
  );
}
